<form [formGroup]="searchForm" [style.width]="searchInputWidth()">
  <lib-input
    [inputFormControlName]="'search'"
    [id]="'search'"
    [type]="'text'"
    [name]="'search'"
    [placeholder]="placeholder() | transloco"
    [startIconTemplate]="startIconTemplate"
    [endIconTemplate]="endIconTemplate"
    (typing)="handleTyping($event)"
    (keyPressedType)="pressedKeyType.emit($event)"
    (endIconCLick)="handleClearSearch()"
    [showEndIconWhenInputHasValue]="true" />

  <ng-template #startIconTemplate>
    <lib-search-icon [iconClass]="'size-5 text-neutral-500'" />
  </ng-template>

  <ng-template #endIconTemplate>
    <lib-tag-cross-icon [iconClass]="'size-5 text-neutral-500'" />
  </ng-template>
</form>
